import Container from "react-bootstrap/esm/Container";

export function Socials() {
    return (
        <Container>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />

            <div class="icon-bar">
                <a href="https://github.com/leonn00albert" class="github"><i class="fa fa-github"></i></a>
                <a href="https://www.linkedin.com/in/leon-a-120333176" class="linkedin"><i class="fa fa-linkedin"></i></a>
            </div>


        </Container>

    )
}